import { Col, Row } from 'react-styled-flexboxgrid';

import Image from '@/components/Image';
import Link from 'next/link';
import { rem } from 'polished';
import styled from 'styled-components';

const Name = styled.h5`
  font-size: ${rem(32)};
  font-weight: bold;
  margin: 0 0 1rem 0;
`;

const Bio = styled.p`
  font-size: 1rem;
  font-weight: normal;
`;

const AuthorProfile = ({ author }) => {
  const { name = '', shortBio = '', image, slug } = author;
  const profileSlug = slug && slug.current ? slug.current : null;

  return (
    <Row center="sm">
      <Col xs={6} sm={4} md={3} lg={3}>
        {image && <Image image={image.image} width={180} alt={name} />}
      </Col>
      <Col xs={12} sm={8}>
        <Name>{name}</Name>
        <Bio>
          {shortBio}
          {profileSlug && ' '}
          {profileSlug && <Link href={`/team-profiles/${profileSlug}`}>{`Read more about ${name}`}</Link>}
        </Bio>
      </Col>
    </Row>
  );
};

export default AuthorProfile;
